export default {
  MuiMenuItem: {
    styleOverrides: {
      root: {
        textTransform: 'uppercase' as const,
      },
    },
  },
}
